import type { StepProps } from 'antd';
import { Divider, Steps } from 'antd';

import type {
  RoomScrapped,
  RoomsWithInventory,
  SyncStatus,
} from 'app/typings/autoInventory';
import type { ExtranetPackage } from 'app/typings/packages';
import { amplitudeTrack } from 'app/utils/track/amplitude';

import type { FormValues } from '../../Utils';
import { BAR } from '../Steps/BAR/BAR';
import { Discount } from '../Steps/Discount/Discount';
import { Preview } from '../Steps/Preview/Preview';
import { RoomMapping } from '../Steps/RoomMapping/RoomMapping';

import './AutoInventoryConfiguration.scss';

type ConfigurationProps = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  setFormData: React.Dispatch<React.SetStateAction<FormValues>>;
  items: StepProps[];
  hotelId: number;
  values: FormValues;
  scrappingRooms: RoomScrapped[];
  scrappingInventory: RoomsWithInventory[];
  setDiscountStepHasError: (val: boolean) => void;
  setScrappingRooms: (val: RoomScrapped[]) => void;
  setSyncStatus: (syncStatus: SyncStatus) => void;
  setInitConfiguration: (init: boolean) => void;
  packages: ExtranetPackage[];
};

export const AutoInventoryConfiguration = ({
  currentStep,
  setCurrentStep,
  setFormData,
  items,
  hotelId,
  values,
  scrappingRooms,
  scrappingInventory,
  setDiscountStepHasError,
  setScrappingRooms,
  setSyncStatus,
  setInitConfiguration,
  packages,
}: ConfigurationProps) => {
  const onChange = (value: number) => {
    setCurrentStep(value);

    setFormData((prevState) => ({
      ...prevState,
      ...values,
    }));

    amplitudeTrack('Click on next step', {
      step: items[value].title as string,
    });
  };

  const renderSteps = () => {
    switch (currentStep) {
      case 0:
        return (
          <RoomMapping
            hotelId={hotelId}
            scrappingRooms={scrappingRooms}
            setScrappingRooms={setScrappingRooms}
            setSyncStatus={setSyncStatus}
            setInitConfiguration={setInitConfiguration}
          />
        );
      case 1:
        return <BAR values={values} />;
      case 2:
        return (
          <Discount
            values={values}
            packages={packages}
            setDiscountStepHasError={setDiscountStepHasError}
          />
        );
      case 3:
        return (
          <Preview
            packages={packages}
            scrappingInventory={scrappingInventory}
            formData={values}
          />
        );

      default:
        return <></>;
    }
  };

  return (
    <>
      <Steps
        type="navigation"
        size="small"
        current={currentStep}
        onChange={onChange}
        className="site-navigation-steps"
        items={items}
      />
      <Divider />
      <div className="container-modal">{renderSteps()}</div>
    </>
  );
};
